/**
 * 用户登录、登出，设置用户信息，清除token等
 */

import { studentLogin, logout } from '@/api/login'
import { getUserInfo, getViewCamp } from '@/api/user'
import { getFinishEveryTiku } from '@/api/preliminaryClassic'
import { getToken,setToken, removeToken } from '@/utils/auth'
// 创建初始化状态
let state = {
	token: getToken(),
	userInfo: {},
	permissions: [],
	finishEveryTiku: {
		finish: false,
		rank: 0
	},
	application: 0
}

// 创建改变状态的方法
const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token;
	},
	SET_USER_INFO: (state, userinfo) => {
		state.userInfo = userinfo;
	},
	SET_PERMISSIONS: (state, permissions) => {
		state.permissions = permissions;
	},
	SET_FINISHEVERYTIKU: (state, finishEveryTiku) => {
		state.finishEveryTiku = finishEveryTiku;
	},
	SET_APPLICATION:(state, application)=>{
		state.application = application;
	}
}
// 创建驱动方法改变mutations
const actions = {
	login({ commit }, userInfo) {
		return new Promise((resolve, reject) => {
			studentLogin(userInfo).then(res => {
				const { data } = res;
				commit('SET_TOKEN', data.token);
				setToken(data.token);
				resolve(res)
			}).catch(error => {
				reject(error);
			})
		})
	},
	logout({ dispatch }){
		return new Promise((resolve, reject) => {
			logout().then(res => {
				dispatch('resetToken')
				resolve(res)
			}).catch(error => {
				reject(error);
			})
		})
	},
	resetToken({ commit }){
		return new Promise(resolve => {
			removeToken();
			resolve()
		})
	},
	getUserInfo({ commit, state }){
		return new Promise((resolve, reject) => {
			getUserInfo({token: state.token}).then(res => {
				const { data } = res;
				commit('SET_USER_INFO', data.userInfo);
				commit('SET_PERMISSIONS', data.operateList);
				resolve(res)
			}).catch(error => {
				reject(error);
			})
		})
	},
	getFinishEveryTiku({ commit, state }){
		return new Promise((resolve, reject) => {
			getFinishEveryTiku({token: state.token}).then(res => {
				const { data } = res;
				commit('SET_FINISHEVERYTIKU', data);
				resolve(res)
			}).catch(error => {
				reject(error);
			})
		})
	},
	setFinishEveryTiku({ commit }, data){
		return new Promise(resolve => {
			commit('SET_FINISHEVERYTIKU', data);
			removeToken();
			resolve()
		})
	},
	getViewCamp({ commit, state }){
		return new Promise((resolve, reject) => {
			getViewCamp({token: state.token}).then(res => {
				const { data } = res;
				commit('SET_APPLICATION', data.application);
				resolve(res)
			}).catch(error => {
				reject(error);
			})
		})
	}
}
// 输出store
export default {
	state,
	mutations,
	actions
};
